module.exports = __webpack_public_path__ + "static/media/BagelSpeech.30bee685.svg";